import { _AbstractSoundInstance } from "./abstractSoundInstance.js";
/** @internal */
export class _StaticSoundInstance extends _AbstractSoundInstance {
}
//# sourceMappingURL=staticSoundInstance.js.map